import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { deleteMaterialsFromAPI, fetchMaterialsFromAPI, uploadMaterialFileToAPI } from "../../../services/MaterialService";


export const fetchMaterials = createAsyncThunk(
  "materials/fetchMaterials",
  async ({ page, perPage, search, columnFilters, sort }, { rejectWithValue }) => {
    try {
      const response = await fetchMaterialsFromAPI(page, perPage, search, columnFilters, sort);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal mengambil data pengguna");
    }
  }
);


export const deleteMaterial = createAsyncThunk(
  "materials/deleteMaterial",
  async ({vendorCode, matlCode}, { rejectWithValue }) => {
    try {
      const response = await deleteMaterialsFromAPI(vendorCode, matlCode);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal menghapus data pengguna");
    }
  }
);

// Upload Material File
export const uploadMaterialFile = createAsyncThunk(
  "materials/uploadMaterialFile",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await uploadMaterialFileToAPI(formData);
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error?.message || "Upload gagal.",
        detail: error?.detail || [],
        status: error?.status || "failed"
      });
    }
  }
);


const materialSlice = createSlice({
  name: "materials",
  initialState: {
    materials: [],
    currentPage: 1,
    lastPage: 1,
    perPage: 10,
    firstItem: 1,
    materialSearch: "",
    loading: false,
    error: null,
    totalCount:0,
    vendors: 0,
    projects: 0,
    units: 0,
    keywordSearch:"",
    columnFilters: {} // New state for column-specific filters
  },
  reducers: {
    setSearchMaterial: (state, action) => {
      state.materialSearch = action.payload;
    },
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setVisibilityFilter: (state, action) => {
      state.currentFilter = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setKeywordSearch: (state, action) => {
      state.keywordSearch = action.payload;
    },
    setColumnFilters: (state, action) => {
      state.columnFilters = action.payload;
    },
    resetMaterialState: (state) => {
      state.materials = [];
      state.currentPage = 1;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMaterials.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMaterials.fulfilled, (state, action) => {
        const materials = action.payload.materials;
        state.loading = false;
        state.materials = materials.data;
        state.currentPage = materials.current_page;
        state.lastPage = materials.last_page;
        state.perPage = materials.per_page;
        state.firstItem = materials.from; // ✅ Ambil `from` dari API
        state.totalCount = materials.total;
        state.vendors = materials.vendors ?? 0;
        state.projects = materials.projects ?? 0;
        state.units = materials.units ?? 0;
      })
      .addCase(fetchMaterials.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteMaterial.fulfilled, (state, action) => {
        state.materials = state.materials.filter(material => material.id !== action.payload);
      })
      .addCase(deleteMaterial.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(uploadMaterialFile.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadMaterialFile.fulfilled, (state, action) => {
        state.loading = false;
        // Optionally refresh the material list after successful upload
        // You can dispatch fetchMaterials here if needed
      })
      .addCase(uploadMaterialFile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setSearchMaterial, setPage, setVisibilityFilter, setPerPage, setKeywordSearch, setColumnFilters, resetMaterialState } = materialSlice.actions;
export default materialSlice.reducer;
